export const boxClasses = {
  root: 'MuiBox-root',
}
